

const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec))

const searchShippingDayElement = async () => {
  for (let i = 0; i < 40; i++) {
      const shippingDayElement = document.querySelector('.haiso_date')
      if (shippingDayElement) {
          return shippingDayElement
      }
      await sleep(200)
  }
  return null
}
    
fetch('/cart.js').then(
    async cart => {
        const res = await cart.json()
        const isGiftEnabledItemInCart = res.items.some(item =>
            item.properties &&
                'ギフト購入' in item.properties &&
                item.properties['ギフト購入'] === '有効',
        )
        if (isGiftEnabledItemInCart) {
          
          await searchShippingDayElement()
          for (let i = 0; i < 100; i++) {
            const elements  = document.querySelectorAll('.haiso_date, .haiso_time, .cart__delivery-date-section, .js-qty__adjust')
            if (elements.length > 0) {
              elements.forEach(element => element.remove())
            } else {
              break
            }
            await sleep(200)
          }
        }                                        
    },
    error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
    }
);